import { graphql } from "@/lib/gql/__generated__";

export const PlanArticleUpdate_DesignPage_Query = graphql(`
	mutation PlanArticleUpdate_DesignPage($input: PlanArticleInput!) {
		planArticleUpdate(input: $input) {
			userErrors
			plan {
				id
				hotelID
				planID
				inSale
				isPrivate
				isRequest
				isDayTrip
				isReservedAtLeastOnce
				name
				mainTarget
				mainKeyVisual {
					bucket
					key
					region
					mimeType
					fileName
				}
				keyVisuals {
					bucket
					key
					region
					mimeType
					fileName
				}
				article {
					bucket
					key
					region
					mimeType
					fileName
				}
				articleTitle
				availableRoomIDs
				availableOptionIDs
				requiredOptionIDs
				defaultDiscountID
				availableDiscountIDs
				kidsPolicy {
					kidsMaxAge
					kidsDiscountType
					ratio
					static {
						currencyType
						amount
					}
				}
				cancelPolicy {
					beforeDays
					chargeRatio
				}
				checkInStart
				checkInEnd
				checkOut
				longStayParams {
					minimumStayDates
				}
				shortStayParams {
					maximumStayDates
				}
				isUncancelable
				isUnchangeable
				isChangeOnlyOption
				roomChangeDisable
				maxRoomNum
				minRoomNum
				minimumPeopleNumPerRoom
				maxPeopleNumPerRoom
				notSendCinMail
				emailTemplateReservation {
					atCreated
					atUpdated
					atCanceled
					atCin
				}
				isNoAddressNeeded
				isShowRoomForGuest
				questions {
					questionID
					required
					questionType
					question
					options
				}
				isHiddenHotelQuestions
				onlyUseLocalPayment
				onlyUseCreditPayment
				saleTypeForTerm
				saleStart
				saleEnd
				stayableStart
				stayableEnd
				stayableDayOfTheWeek
				checkInAvailableDayOfTheWeek
				requiredPrepMillisecond
				saleStartBeforeDate
				maxStockNum
				soldNumTotal
				maxDailyStockNum
				stockTypeTerm
				stockTypeTarget
				doNotCountKidsAsStock
				billingTypeTerm
				billingTypeTarget
				price {
					currencyType
					amount
				}
				staticPriceParams {
					staticRoomPrices {
						roomID
						roomName
						prices {
							adultNum
						}
					}
				}
				isRoomPriceFree
				isCoSleepingKidsPriceActive
				coSleepingKidsPrice {
					currencyType
					amount
				}
			}
		}
	}
`);
